'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
var Chip = require('@material-ui/core/Chip');
var CircularProgress = require('@material-ui/core/CircularProgress');
var ListItem = require('@material-ui/core/ListItem');
var ListItemIcon = require('@material-ui/core/ListItemIcon');
var ListItemText = require('@material-ui/core/ListItemText');
var ArrowForwardIcon = require('@material-ui/icons/ArrowForwardRounded');
var ArrowDownIcon = require('@material-ui/icons/ArrowDownwardRounded');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Chip__default = /*#__PURE__*/_interopDefaultLegacy(Chip);
var CircularProgress__default = /*#__PURE__*/_interopDefaultLegacy(CircularProgress);
var ListItem__default = /*#__PURE__*/_interopDefaultLegacy(ListItem);
var ListItemIcon__default = /*#__PURE__*/_interopDefaultLegacy(ListItemIcon);
var ListItemText__default = /*#__PURE__*/_interopDefaultLegacy(ListItemText);
var ArrowForwardIcon__default = /*#__PURE__*/_interopDefaultLegacy(ArrowForwardIcon);
var ArrowDownIcon__default = /*#__PURE__*/_interopDefaultLegacy(ArrowDownIcon);

var _excluded = ["title", "icon", "isLoading", "isSubmenu", "isLast", "isOpen", "isAlwaysOpen", "onClick", "isSelected", "children", "tag"];
var useStyles = styles.makeStyles(theme => ({
  listItem: {
    color: props => props.isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
    position: 'relative',
    paddingLeft: props => props.isSubmenu ? 48 : 16,
    backgroundColor: props => props.isSelected && props.isSubmenu ? theme.palette.primary[50] : props.isSelected ? theme.palette.grey[200] : props.isSubmenu ? theme.palette.grey[200] : 'transparent',
    '&:hover': {
      backgroundColor: props => props.isSelected ? theme.palette.grey[300] : props.isSubmenu ? theme.palette.grey[300] : theme.palette.grey[300],
      '&:active': {
        backgroundColor: theme.palette.primary[50]
      }
    }
  },
  listItemIcon: {
    color: props => props.isSelected ? theme.palette.primary.main : theme.palette.text.secondary
  },

  /** Styles applied to `CircularProgress`. */
  loader: {
    color: theme.palette.text.secondary
  },
  arrow: {
    color: props => props.isHovered ? theme.palette.primary.main : theme.palette.text.secondary
  }
}));
/**
 * Main menu item.
 */

var MenuPanelItem = _ref => {
  var {
    title,
    icon,
    isLoading = false,
    isSubmenu = false,
    isLast = false,
    isOpen: isOpenFromProps = false,
    isAlwaysOpen = false,
    onClick,
    isSelected,
    children,
    tag = ''
  } = _ref,
      listItemProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var [isHovered, setIsHovered] = React.useState(false);
  var classes = useStyles({
    isHovered,
    isSelected,
    isSubmenu
  });
  var isOpen = isAlwaysOpen || isOpenFromProps;
  var submenuItems = React__default['default'].Children.toArray(children).map(child => {
    if (child.type.displayName !== 'MenuPanelItem') {
      throw new Error('Submenu items must be Menu Item components.');
    }

    if (React__default['default'].Children.count(child.props.children)) {
      throw new Error('Submenu items cannot have nested submenu items.');
    }

    return child;
  });
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ListItem__default['default'], _rollupPluginBabelHelpers['extends']({
    dense: true,
    button: !!onClick,
    divider: isOpen || isLast,
    onClick: onClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    className: classes.listItem
  }, listItemProps), (!!icon || isLoading) && !isSubmenu && /*#__PURE__*/React__default['default'].createElement(ListItemIcon__default['default'], {
    className: classes.listItemIcon
  }, isLoading ? /*#__PURE__*/React__default['default'].createElement(CircularProgress__default['default'], {
    className: classes.loader,
    size: 16
  }) : icon), /*#__PURE__*/React__default['default'].createElement(ListItemText__default['default'], {
    primary: tag ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        marginRight: 8
      }
    }, title), /*#__PURE__*/React__default['default'].createElement(Chip__default['default'], {
      size: "small",
      label: tag,
      color: "primary"
    })) : title,
    primaryTypographyProps: {
      color: 'inherit',
      display: 'inline',
      component: 'div'
    }
  }), !isAlwaysOpen && submenuItems.length > 0 && (isHovered || isOpen) && /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      position: 'absolute',
      top: 8,
      right: 8
    }
  }, isOpen ? /*#__PURE__*/React__default['default'].createElement(ArrowDownIcon__default['default'], null) : /*#__PURE__*/React__default['default'].createElement(ArrowForwardIcon__default['default'], null))), isOpen && submenuItems.map((child, index) => /*#__PURE__*/React__default['default'].cloneElement(child, {
    isSubmenu: true,
    isLast: index === submenuItems.length - 1
  }) // sub-MenuPanelItem children are not rendered
  ));
};
MenuPanelItem.propTypes = {
  /** Title of the item */
  title: index.string.isRequired,

  /** Icon element for the item */
  icon: index.node,

  /** Handle click event */
  onClick: index.func,

  /** Is the item selected? */
  isSelected: index.bool,

  /** Flag if item should be expanded. */
  isOpen: index.bool,

  /** Flag if item should always be expanded. Mutually exclusive with `isOpen` */
  isAlwaysOpen: index.bool,

  /** Submenu items if the item is expanding. */
  children: index.node,

  /** Optional tag that highlights a feature in a menu section. */
  tag: index.string,
  isLoading: index.bool,
  isSubmenu: index.bool,
  isLast: index.bool
};
MenuPanelItem.displayName = 'MenuPanelItem';

exports.MenuPanelItem = MenuPanelItem;
exports.default = MenuPanelItem;
